import { Moment } from 'moment';
import { FC } from 'react';
import { HumanisedDate } from '../humanised-date';
import * as styles from './date-from-to.module.css';

interface DateFromTo {
  from?: Moment | null;
  to?: Moment | null;
}
export const DateFromTo: FC<React.PropsWithChildren<DateFromTo>> = ({
  from,
  to,
}) => (
  <>
    {from && (
      <span id="from">
        <HumanisedDate timestamp={from} />
      </span>
    )}

    {from && to && <span className={styles.separator}>-</span>}
    {to && (
      <span id="to">
        <HumanisedDate timestamp={to} />
      </span>
    )}
  </>
);
